document.querySelectorAll("#shopify-section-template--18101252980933__slideshow .stacked-text--title").forEach(span => {
  span.textContent = span.textContent.split(" ").slice(0, 2).join(" ");
});

// BOGO: "+" adds 2, "-" removes 2 (min 1 pair) for bogo cart items
document.addEventListener('click', function (e) {
  var plusBtn = e.target.closest('.quantity-selector--plus');
  var minusBtn = e.target.closest('.quantity-selector--minus');
  if (!plusBtn && !minusBtn) return;

  var cartItem = (plusBtn || minusBtn).closest('.cart--item[data-bogo="true"]');
  if (!cartItem) return;

  var input = cartItem.querySelector('.quantity-selector--input');
  if (!input) return;

  var current = parseInt(input.value) || 0;

  if (plusBtn) {
    // Pre-increment by 1 so theme's +1 = +2 total
    input.value = current + 1;
  } else {
    if (current <= 2) {
      // At minimum pair — swallow the click to avoid stale input display
      e.stopImmediatePropagation();
      e.preventDefault();
    } else {
      // Pre-decrement by 1 so theme's -1 = -2 total
      input.value = current - 1;
    }
  }
}, true);

// BOGO: double the quantity for products tagged 'bogo' when added to cart
document.addEventListener('submit', function (e) {
  const bogoEl = e.target.querySelector('product-buy-buttons-element[data-bogo="true"]');
  if (!bogoEl) return;

  const qtyInput = e.target.querySelector('[name="quantity"]');
  if (!qtyInput) return;

  const original = parseInt(qtyInput.value) || 1;
  qtyInput.value = original * 2;

  // Reset after the theme has read the value and submitted
  setTimeout(() => { qtyInput.value = original; }, 100);
}, true);
